var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdeaPanel1MeThumbsDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 227 457",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#fff;stroke:#000;stroke-linecap:round;stroke-linejoin:round;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 227,
    height: 457
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M141.85,264.07c-1.92-14.55-6.3-28.93-14.37-41.21a9.55,9.55,0,0,0-2.57-2.69c-4.83-3.29-8.84.43-12.63,3-2.26,1.53-4.32,4.37-7.37,3.85a3.37,3.37,0,0,0-3.8,3.08,87.64,87.64,0,0,1-4,19.85c-2.74,8.43-7.13,15.49-14,18.38a24.1,24.1,0,0,0-7.92,6.57,4.38,4.38,0,0,0-.54,4.17C75.94,282,80,281.71,83,280.6a36.33,36.33,0,0,0,21.48-23.84L100,284.52c-.53,5.37-3.82,28.31-1.15,38.18.37,1.38,20.71-1.64,31.07-2.46,2.63-.21,11.53.26,11.57.08,1.12-4.3.63-9.9.94-14.56C143.36,291.87,143.68,277.87,141.85,264.07Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.16,277.23l.7-3.22c.61-2.05,1.56-3.46,3.25-3.38l19.3,1a3.33,3.33,0,0,1,2.88,3.69l-.7,3.23C89,280.82,88,282,86.34,281.93l-19.3-1A3.34,3.34,0,0,1,64.16,277.23Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M119.79,236.38c-7.16,21.56-15.67,31.51-31,37.57a4,4,0,0,1-1-.45,9.43,9.43,0,0,0-3-.93c-1.46-.24-2.76-.09-3.43.84-.82,1.12-.12,2,.43,2.95h0a7,7,0,0,0-2.94,1.4,4,4,0,0,0-1.67,3.9c.44,1.73,2.34,2.62,4.06,3.08,5.89,1.55,12.57-.75,18.18-3.1s10.54-6.57,15-10.69c7.82-7.22,12.83-15.76,15.62-28.1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.25,250.19a32.4,32.4,0,0,0,10.53,7.89"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M97.4,250.28a20.07,20.07,0,0,0,6.92,5.73,57.74,57.74,0,0,1,1.1-13.82"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M81.78,271s.33,1.35,1.53,1.36c2.3,0,3.1-2.6,3.1-2.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaPanel1MeThumbsDown);
export default __webpack_public_path__ + "static/media/Idea_Panel_1_Me_ThumbsDown.594ce2059e5707a320b18860fdc05dc0.svg";
export { ForwardRef as ReactComponent };